import ValueLabel from './ValueLabel';

enum PropertyType {
  Date = 'Date',
  Text = 'Text',
  Number = 'Number',
  Dropdown = 'Dropdown',
}

interface FilterProperty {
  name: string;
  label: string;
  type: PropertyType;
}

interface DateProperty extends FilterProperty {
  type: PropertyType.Date;
}

interface TextProperty extends FilterProperty {
  type: PropertyType.Text;
  relations: Array<ValueLabel>;
}

interface NumberProperty extends FilterProperty {
  type: PropertyType.Number;
  relations: Array<ValueLabel>;
}

interface DropdownProperty extends FilterProperty {
  type: PropertyType.Dropdown;
  relations: Array<ValueLabel>;
  values: Array<ValueLabel>;
  loading?: boolean;
}

type Property = DateProperty | TextProperty | NumberProperty | DropdownProperty;

export { DateProperty, TextProperty, NumberProperty, DropdownProperty, Property, PropertyType };
